import React, { useEffect, useState } from 'react'
import ProgressBar from 'react-bootstrap/ProgressBar'
import './styles.scss'
import { useAppSelector } from 'hooks/store'

export interface ProgressProps {
  currentProgress: number
  progressText: string
}

const ProgressBarComponent: React.FC<ProgressProps> = (
  props: ProgressProps
) => {
  const { currentProgress, progressText } = props
  const activeCase = useAppSelector((state) => state.activeCase)
  const authentication = useAppSelector((state) => state.authentication)

  const [debtor, setDebtor] = useState('')

  useEffect(() => {
    const isJointCase = activeCase?.matter?.isJoint
    if (!isJointCase) {
      return
    }

    const loggedInUserEmailAddress = authentication?.account?.emailAddress || ''
    const isDebtor1 =
      loggedInUserEmailAddress === activeCase?.matter?.debtor1EmailAddress
    if (isDebtor1) {
      setDebtor('Debtor 1')
      return
    }

    const isDebtor2 =
      loggedInUserEmailAddress === activeCase?.matter?.debtor2EmailAddress
    if (isDebtor2) {
      setDebtor('Debtor 2')
    }
  }, [])

  return (
    <div className='progress-bar-container'>
      <div className='progress-text-container'>
        <div
          className='progress-section-text'
          data-testid='progress-section-text'
        >
          {progressText}
        </div>
        <div
          className='progress-debtor-text'
          data-testid='progress-debtor-text'
        >
          {debtor}
        </div>
      </div>
      <ProgressBar now={currentProgress} />
    </div>
  )
}

export default ProgressBarComponent
